// extracted by mini-css-extract-plugin
module.exports = {"layer":"Modal_layer__IhhP7","layerBody":"Modal_layerBody__3L4Rv","dimmed":"Modal_dimmed__wl_P5"};